// extracted by mini-css-extract-plugin
module.exports =  {"tab":"e2ff468f85--tab--w0wAJ","active":"e2ff468f85--active--mwGtJ","focus-visible":"e2ff468f85--focus-visible--MXtrR","text":"e2ff468f85--text--oMJVB"};